import styled from 'styled-components';
import { flexbox,
  inlineFlexbox,
  alignItems,
  flexDirection,
  justifyContent } from '../../styles/helpers/flexbox';

const LegendWrapper = styled.span`
    ${flexbox()};
    ${flexDirection('column')};

    position: absolute;
    top: 95px;
    right: 90px;
    padding: 10px;
    width: 200px;
    background-color: white;
    z-index: 9;
    box-shadow: 4px 2px 6px;
    border-radius: 4px;
    font-size: 14px;

    [class*="svgIconComponent--"] {
      height: 24px !important;
      width: 100%;
      ${flexbox()};
      ${alignItems('center')};
      ${justifyContent('center')};

      span {
        ${flexbox()};
      }
    }

    .item {
      ${inlineFlexbox()};
      ${alignItems('center')};

      margin-bottom: 10px;
      background-color: #f4f9f1;
      border-radius: 5px;
      padding: 4px;
    }

    ::after {
      width: 0; 
      height: 0; 
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;        
      border-bottom: 15px solid #fff;
      position: fixed;
      top: 165px;
      right: 215px;
      content: ' ';
      z-index: 9;
    }
`;

const Header = styled.div`
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 10px;

  .sub-heading {
    font-weight: normal;
    margin-top: 10px;
  }
`;

const ColorBlock = styled.div(props => `
    ${inlineFlexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};

    width: 23px;
    height: 23px;
    background-color: ${props.color};

    margin-right: 10px;

    .icon {
      width: 15px;
    }
`);

export {
  LegendWrapper,
  ColorBlock,
  Header
};
